import { render, staticRenderFns } from "./SalidasInventario.vue?vue&type=template&id=07ce0ea2&"
import script from "./SalidasInventario.vue?vue&type=script&lang=js&"
export * from "./SalidasInventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports